<template>
    <div class="accordion">
        <div class="accordion__inner">
            <div class="accordion__tab">
                <div class="accordion__tab--headline">Headline</div>
                <div class="accordion__tab--text">
                    <p>Text</p>
                </div>
                <div class="accordion__trigger" v-on:click="openTab($event)">Trigger<font-awesome-icon icon="chevron-down" class="ml-1" size="1x" :style="{ color: 'white' }"/></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Accordion",
        methods:{
            openTab(event){
                let tab = event.target.previousSibling;
                console.log(event.target.previousSibling)

                if (!tab.classList.contains('active')) {
                    tab.classList.add('active');
                    tab.style.height = 'auto';

                    let height = tab.clientHeight + "px";

                    tab.style.height = '0px';

                    setTimeout(function () {
                        tab.style.height = height;
                    }, 0);
                } else {
                    tab.style.height = '0px';

                    tab.addEventListener('transitionend', function () {
                        tab.classList.remove('active');
                    }, {
                        once: true
                    });
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .accordion__tab--text {
        transition: height .25s ease;
        overflow: hidden;
    }
    .accordion__tab--text:not(.active) {
        display: none;
    }
</style>